import React from 'react'
import { useAtomValue } from 'jotai'

import { Access } from '../../lib'
import * as state from '../../states'
import { TRevenueAgg } from '../../types'
import { IUiTableConfig, UiTable, UiDateInfo } from '../ui'
import * as helpers from '../../helpers'
import { sortRevenueSpendItemsByClickAt } from './RevenueSpendByAccountRevenueDetailsTable'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IRevenueSpendByTeamRevenueDetailsTableProps = {
	items: TRevenueAgg[];
	skip: number;
}


export const RevenueSpendByTeamRevenueDetailsTable = (props: IRevenueSpendByTeamRevenueDetailsTableProps) => {
	const {
		items = [],
		skip = 0
	} = props
	const { t } = useTranslation()
	const profile = useAtomValue(state.profileAtom)
	const $access = new Access(profile ?? null)

	const tableConfig: IUiTableConfig<TRevenueAgg>[] = [
		{
			key: 'clickAt',
			title: t(ALL_LANG_KEY.revenue_spend_by_account_revenue_details_table.column_date_click),
			rowCellFormatter: ({ value, rowData }) => {
				return (
					<UiDateInfo value={value} showDateLong={true}/>
				)
			}
		},
		{
			key: 'saleAt',
			title: t(ALL_LANG_KEY.revenue_spend_by_account_revenue_details_table.column_date_sale),
			rowCellFormatter: ({ value, rowData }) => {
				return (
					<UiDateInfo value={value} showDateLong={true}/>
				)
			}
		},
		{
			key: 'revenue',
			title: t(ALL_LANG_KEY.revenue_spend_by_account_revenue_details_table.column_revenue),
			rowCellFormatter: ({ value, rowData }) => {
				const formatValue = helpers.formatAmount(value)

				return <>{helpers.thousandSeparator(formatValue)}</>
			}
		},
		{
			key: 'offerId',
			title: t(ALL_LANG_KEY.revenue_spend_by_account_revenue_details_table.column_offer),
			rowCellFormatter: ({ rowData }): React.JSX.Element => {
				const offerId = rowData?.offerId ?? null
				const offer = rowData?.offer ?? null
				const name = offer?.name ?? null
				return <>
					<strong>[id: {offerId}]</strong>
					&nbsp;
					{name ?? '?'}
				</>
			}
		},
		{
			key: 'subId',
			title: t(ALL_LANG_KEY.revenue_spend_by_account_revenue_details_table.column_sub_id)
		},
		{
			key: 'subId2',
			title: t(ALL_LANG_KEY.revenue_spend_by_account_revenue_details_table.column_sub_id_2)
		},
		{
			key: 'campaignGroup',
			title: t(ALL_LANG_KEY.revenue_spend_by_account_revenue_details_table.column_campaign_group)
		},
		{
			key: 'ktLogin',
			title: t(ALL_LANG_KEY.revenue_spend_by_account_revenue_details_table.column_kt_group)
		},
		{
			key: 'originalStatus',
			title: t(ALL_LANG_KEY.revenue_spend_by_account_revenue_details_table.column_original_status)
		}
	]

	const sortedItemsByDate = sortRevenueSpendItemsByClickAt(items)
	//TODO: check the filter condition - to add enum ..?
	const filteredItemsByStatus = sortedItemsByDate.filter(
		item => item.originalStatus === 'sale'
	)

	return <>
		<UiTable
			data={filteredItemsByStatus}
			config={tableConfig}
			// TODO: uncomment if necessary
			// classesToAdd={{
			// 	wrapper: 'table-sticky-wrapper table-sticky-wrapper--top-60',
			// }}
		/>
	</>
}